exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".secondary-ts-x-axis {\n  position: absolute;\n}\n.secondary-ts-x-axis g.axis-title.x.axis.bottom text {\n  transform: translateY(-8px);\n}\n", ""]);

